import type { ObjectSchema } from 'yup';
import { number, object, string } from 'yup';

import type { RegionFormValues } from '../types/FormValues';

export const regionValidator: ObjectSchema<RegionFormValues> = object().shape({
  region: number().required('Campo obligatorio'),
  commune: string().required('Campo obligatorio')
});
